import { addWithConfig } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';
import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import { getDesignToken, primitive, spacing } from 'styles/constants';

import componentTheme from './theme';

export const StyledLoyaltyPointsIcon = LoyaltyPointsIcon.withConfig<{
  reversed: boolean;
  color?: string;
}>(({ reversed, color }) => ({
  fill: color ? color : reversed ? getDesignToken('icon-reversed') : getDesignToken('crown-color'),
  size: 17,
}));

export const StyledLoyaltyButton = addWithConfig(ActionButton).withConfig<{ reversed: boolean }>(
  ({ reversed }) => {
    const borderColor = reversed ? 'icon-reversed' : componentTheme.buttonContrastColor;

    return {
      backgroundColor: reversed ? primitive.$bbqBrown : primitive.$mayoEggWhite,

      paddingX: '11px',
      paddingY: spacing.$1_5,
      color: reversed ? getDesignToken('text-reversed') : componentTheme.buttonContrastColor,
      borderColor,
      _hover: {
        borderColor,
      },
      _pressed: {
        borderColor,
      },
      _focusVisible: {
        borderColor,
      },
    };
  }
);
